import createReducer from "src/utils/reduxsauce/createReducer";
import { ActionTypes } from "./actions";

import { defaultState, bindReducers } from "src/utils/genState";

const initialState = {
  ...defaultState("pages"),
};

const setPageState = (state,draft, payload) => {
  const {name,st}=payload;
  if(!state.pages){
    draft.pages={};
  }
    draft.pages[name] = st;
};



export const reducer = createReducer(initialState, {
  ...bindReducers(ActionTypes, {action:"setPageState",async:false,successCb:setPageState}),
});
